import { lazy } from "react"

export const Athletes = lazy(() => import("./athletes"))
